import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { HomeMainComponent } from './home/home-main/home-main.component';
import { MainComponent } from './advertisement/main/main.component';
import { LoginGuard } from './guards/login.guard';
import { ProfileComponent } from './profile/profile.component';
import { ProfileGuard } from './guards/profile.guard';
import { AddAdvertisementComponent } from './add-advertisement/add-advertisement.component';
import { ProvinceResolverService } from './resolver/province-resolver.service';
import { DistrictResolverService } from './resolver/district-resolver.service';
import { MunicipalityResolverService } from './resolver/municipality-resolver.service';
import { PropertyTypeResolverService } from './resolver/property-type-resolver.service'
import { AdResolverService } from './resolver/ad-resolver.service';
import { AdPlanResolverService } from './resolver/ad-plan-resolver.service';
import { Ad5Component } from './advertisement-steps/ad5/ad5.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { PhoneVerificationComponent } from './phone-verification/phone-verification.component';
import { BlogComponent } from './blog/blog.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { EditPropertyComponent } from './edit-property/edit-property.component';
import { BlogSinglePageComponent } from './blog-single-page/blog-single-page.component';
import { LocationComponent } from './location/location.component';
import { SearchLocationComponent } from './search-location/search-location.component';
import { EsewaPaymentSuccessComponent } from './esewa-payment-success/esewa-payment-success.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { PaymentComponent } from './payment/payment.component';
import { PropertiesComponent } from './properties/properties.component';
import { TosComponent } from './tos/tos.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ManagementComponent } from './management/management.component';
import { Ad4Component } from './advertisement-steps/ad4/ad4.component';
import { PropertyAdminPreviewComponent } from './property-admin-preview/property-admin-preview.component';
import { BlogResolverService } from './resolver/blog-resolver.service';
import { OurServicesComponent } from './our-services/our-services.component';
import { LoginRegisterComponent } from './login-register/login-register.component';
import { PropertyResolverService } from './resolver/property-resolver.service';
import { RequestPasswordChangeComponent } from './request-password-change/request-password-change.component';
import { ChangePasswordTokenComponent } from './change-password-token/change-password-token.component';
import { PricingComponent } from './pricing/pricing.component';

const routerOptions: ExtraOptions = {
	anchorScrolling: 'enabled',
	scrollOffset: [0, 64],
	scrollPositionRestoration: 'enabled', 
	onSameUrlNavigation: 'reload', 
	initialNavigation: 'enabled' 
};

  
const routes: Routes = [
	{
		'path': '',
		component: HomeMainComponent,
		resolve: {
			propertyType: PropertyTypeResolverService,
			provinceList: ProvinceResolverService,
			districtList: DistrictResolverService,
			municipalityList: MunicipalityResolverService
		}
	},
	{
		'path': 'home',
		pathMatch:'full',
		redirectTo: ''
	},
	{
		'path': 'location',
		component: LocationComponent,
		resolve: {
			provinceList: ProvinceResolverService,
			districtList: DistrictResolverService,
			municipalityList: MunicipalityResolverService
		}
	},
	{
		'path': 'location/:slug',
		component: SearchLocationComponent,
		resolve: {
			provinceList: ProvinceResolverService,
			districtList: DistrictResolverService,
			municipalityList: MunicipalityResolverService,
			propertyType: PropertyTypeResolverService
		}
	},
	{
		'path': 'services',
		component: OurServicesComponent
	},
	{
		'path': 'property/:id',
		component: MainComponent,
		resolve: {
			provinceList: ProvinceResolverService,
			districtList: DistrictResolverService,
			municipalityList: MunicipalityResolverService,
			propertyAd: PropertyResolverService
		}
	},
	{
		'path': 'property/:id/payment',
		component: PaymentComponent,
		canActivate: [ ProfileGuard ],
		resolve: {
			propertyAd: AdResolverService,
			adPlans: AdPlanResolverService
		}
	},
	{
		'path': 'property/:id/esewa-payment-success',
		component: EsewaPaymentSuccessComponent,
		canActivate: [ ProfileGuard ],
		resolve: {
			propertyAd: AdResolverService
		}
	},
	{
		'path': 'add-property/:step',
	 	component: AddAdvertisementComponent,
		canActivate: [ ProfileGuard ],
		resolve: { 
			provinceList: ProvinceResolverService,
			districtList: DistrictResolverService,
			municipalityList: MunicipalityResolverService,
			adPlans: AdPlanResolverService,
			propertyTypes: PropertyTypeResolverService
		}
	},
	{'path': 'login' , component:LoginRegisterComponent, canActivate: [ LoginGuard ]},
	{'path': 'register' , component:LoginRegisterComponent, canActivate: [ LoginGuard ]},
	{
		'path': 'profile/:page',
		component:ProfileComponent,
		canActivate: [ ProfileGuard ],
		resolve: { 
			municipalityList: MunicipalityResolverService,
			adPlans: AdPlanResolverService
		}
	},
	{
		'path': 'edit-property/:id',
		component: EditPropertyComponent,
		canActivate: [ ProfileGuard ],
		resolve: { 
			provinceList: ProvinceResolverService,
			districtList: DistrictResolverService,
			municipalityList: MunicipalityResolverService,
			adPlans: AdPlanResolverService,
			propertyTypes: PropertyTypeResolverService,
			propertyAd: PropertyResolverService
		}
	},
	{'path': 'blogs', component: BlogComponent},
	{'path': 'blog/:slug', component: BlogSinglePageComponent, resolve: { blog: BlogResolverService } },
	{'path': 'about', component: AboutComponent},
	{'path': 'contact', component: ContactComponent},
	{'path': 'adPlan', component: Ad5Component, resolve: {adPlans: AdPlanResolverService}},
	{'path': 'verify-account', component: PhoneVerificationComponent, canActivate: [ LoginGuard ]},
	{
		'path': 'search-result/:type/:listingFor/:keyword',
		component: SearchResultComponent,
		resolve: {
			propertyType: PropertyTypeResolverService,
			provinceList: ProvinceResolverService,
			districtList: DistrictResolverService,
			municipalityList: MunicipalityResolverService,
		}
	},
	{
		'path': 'search-result/:type/:listingFor',
		component: SearchResultComponent,
		resolve: {
			propertyType: PropertyTypeResolverService,
			provinceList: ProvinceResolverService,
			districtList: DistrictResolverService,
			municipalityList: MunicipalityResolverService,
		}
	},
	{
		'path': 'properties',
		component: PropertiesComponent,
		resolve: {
			propertyType: PropertyTypeResolverService,
			provinceList: ProvinceResolverService,
			districtList: DistrictResolverService,
			municipalityList: MunicipalityResolverService,
		}
	},
	{'path': 'tos', component: TosComponent},
	{'path': 'privacy-policy', component: PrivacyComponent},
	{'path': 'property-management', component: ManagementComponent},
	{'path': '404', component: NotFoundComponent},
	{
		'path': 'property-preview/:id',
		component: PropertyAdminPreviewComponent,
		resolve: {
			provinceList: ProvinceResolverService,
			districtList: DistrictResolverService,
			municipalityList: MunicipalityResolverService,
			propertyAd: AdResolverService
		}
	},
	{'path': 'reset-password', component: RequestPasswordChangeComponent},
	{'path': 'change-password', component: ChangePasswordTokenComponent},
	{'path': 'pricing', component: PricingComponent},
	{'path': 'test', component: Ad4Component},
	{'path': '**', pathMatch: 'full', redirectTo: '404'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
